import { GridDefinitionFactory } from '@b2b/common/factories/gridDefinition/types';
import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ColumnDef, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

MembershipOfferingsController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  'ApiService',
  'HelpersService',
  'ValidateService',
  'PermissionsService',
  'ConfigService',
  'PosConfigService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'NoticeFactory',
];

function MembershipOfferingsController(
  $scope: IScope & { membershipOfferings: TODO },
  $state: StateService,
  $uibModal: UIBModalService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  HelpersService: TODO,
  ValidateService: TODO,
  PermissionsService: PermissionsService,
  ConfigService: TODO,
  PosConfigService: TODO,
  GridStateFactory: GridStateFactory,
  GridDefinitionFactory: GridDefinitionFactory,
  NoticeFactory: NoticeFactory
) {
  const ctrl = {
    model: [] as TODO[],

    categoryId: '',
    searchQuery: '',
    isLoaded: false,

    viewId: '',
    gridName: $state.current.name + '.grid0',

    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    notice: new NoticeFactory(),

    optionsOverride: {
      enableRowSelection: false,
      multiSelect: false,
      noUnselect: false,
      data: 'membershipOfferings.model',
      appScopeProvider: {
        remove: (id) => {
          ctrl.remove(id);
        },
        onDblClick: (row) => {
          ctrl.onGridDoubleClick(row);
        },
        onDataGridPaginate: (newPageNumber, newPageSize, sortField, sortDirection) => {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: (grid, columns) => {
          ctrl.onDataGridSortChange(grid, columns);
        },
      },
      columnDefs: [
        {
          field: 'id',
          displayName: 'Id',
          visible: false,
        },
        {
          field: 'name',
          displayName: 'Name',
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'startDate',
          displayName: 'Start Date',
          visible: false,
        },
        {
          field: 'endDate',
          displayName: 'End Date',
        },
        {
          field: 'displayDuration',
          displayName: 'Duration',
        },
      ] as ColumnDef[],
    },

    init: function () {
      ctrl.viewId = $state.current.name ?? '';

      if ($state.params && $state.params.categoryId) {
        ctrl.categoryId = $state.params.categoryId;
      }

      if (PermissionsService.check('MEMBERSHIP_OFFERING_DELETE')) {
        ctrl.optionsOverride.columnDefs.push({
          field: 'remove',
          displayName: 'Remove',
          width: 80,
          enableHiding: false,
          enableSorting: false,
          onCellNavClick: (row, col) => {
            ctrl.remove(row.entity.id);
          },
          cellTemplate: `<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>`,
        });
      }

      if (PermissionsService.check('MEMBERSHIP_OFFERING_UPDATE')) {
        ctrl.optionsOverride.columnDefs.unshift({
          field: 'edit',
          displayName: 'Edit',
          enableHiding: false,
          enableSorting: false,
          width: 50,
          onCellNavClick: (row, col) => {
            ctrl.onGridDoubleClick(row);
          },
          cellTemplate: `<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>`,
        });
      }

      ctrl.gridDefinition.init(ctrl.gridName, ctrl.optionsOverride, ctrl.viewId, $state.current.data.enablePreferences);
      $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.initData);

      $scope.$on('MembershipOfferings::Update', ctrl.onMembershipOfferingsUpdate);
    },

    initData: function () {
      const props = ctrl.gridDefinition.getGridState();
      ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);

      ctrl.getOfferings();
    },

    getOfferings: function () {
      const props = ctrl.gridState.getGridState();

      ApiService.membership.offerings
        .list({
          ...props,
          salesChannels: 'online',
          isPublished: '0',
          categoryId: $state.params.categoryId,
        })
        .then((response) => ctrl.success.getOfferings(response))
        .catch((response) => ctrl.error.getOfferings(response));
    },

    create: function () {
      ctrl.notice.hideErrorMessages();
      ctrl.notice.hideSuccessMessages();
    },

    findOfferings: function (id) {
      let r: { offering: TODO; index: number } | false = false;

      for (let i = 0, ii = ctrl.model.length; i < ii; i++) {
        if (ctrl.model[i].id === id) {
          r = {
            offering: ctrl.model[i],
            index: i,
          };
          break;
        }
      }

      return r;
    },

    remove: function (id) {
      const found = ctrl.findOfferings(id);

      if (!found) {
        return;
      }

      $uibModal
        .open<TODO>({
          templateUrl: 'views/application/views/membership/offerings/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'MembershipOfferingsModalsRemoveController',
          resolve: {
            currentOffering: () => found.offering,
          },
        })
        .result.then(() => {
          ApiService.membership.offerings
            .remove({
              categoryId: $state.params.categoryId,
              offeringId: found.offering.id,
            })
            .then((response) => ctrl.success.remove(response))
            .catch((response) => ctrl.error.remove(response));
        })
        .catch(() => {
          // noop
        });
    },

    search: function () {
      ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
      $scope.$broadcast('DataGrid::Search', { name: ctrl.gridName });
    },

    process: function (model) {
      for (let i = 0, ii = model.length; i < ii; i++) {
        model[i].displayDuration =
          parseInt((model[i].duration / 12) as TODO, 10) + ' years ' + (model[i].duration % 12) + ' months';
      }

      return model;
    },

    success: {
      init: function (response) {},

      getOfferings: function (response) {
        ctrl.model = ctrl.process(response.data.payload.list);
        ctrl.gridDefinition.options.totalItems = response.data.payload.pagination.count;
        ctrl.gridDefinition.isLoaded = true;
        ctrl.isLoaded = true;
        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.model.length,
          });
        }, 10);
      },

      remove: function (response) {
        $scope.$emit('MembershipOfferings::Remove');
        ctrl.search();
      },
    },

    error: {
      init: function (response) {},
      getOfferings: function (response) {
        ctrl.gridDefinition.isLoaded = true;
        ctrl.isLoaded = true;
      },
      remove: function (response) {
        $scope.$emit('MembershipOfferings::Error', response);
      },
    },

    onMembershipOfferingsUpdate: function (e, data) {
      ctrl.model = data.offerings;
    },

    onGridDoubleClick: function (item) {
      if (PermissionsService.check('MEMBERSHIP_OFFERING_UPDATE')) {
        $state.go('application.membership.offerings.edit', {
          categoryId: $state.params.categoryId,
          offeringId: item.entity.id,
        });
      }
    },

    onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
      ctrl.gridState.updateGridState(newPage, pageSize);

      if (sortField) {
        ctrl.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        ctrl.gridState.updateGridState(null, null, null, sortDirection);
      }

      ctrl.getOfferings();
    },

    onDataGridSortChange: function (grid, columns, page = null) {
      const data = columns[0];
      ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);

      ctrl.getOfferings();
    },

    onDataGridSelectionChange: function (row, e) {},
  };

  $scope.membershipOfferings = ctrl;
  ctrl.init();
}

export const MembershipOfferingsControllerModule = angular
  .module('acme.view.application.membership.offerings.controllers', [
    uiRouter,
    'ui.bootstrap',
    'ui.sortable',
    'acme.common.service.api',
    'acme.common.service.config',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.service.posConfig',
    'acme.common.service.permissions',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.view.application.pos.create.images.removeModal.controllers',
    'acme.view.application.membership.offerings.modals.remove.controllers',
    'agGrid',
  ])
  .controller('MembershipOfferingsController', MembershipOfferingsController).name;
